var map = {
	"./cancel.svg": 18169,
	"./chevron-down.svg": 67407,
	"./chevron-left.svg": 17363,
	"./flag-at.svg": 39609,
	"./flag-gb.svg": 1518,
	"./login.svg": 20493,
	"./menu.svg": 92134,
	"./search.svg": 96436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99476;